
import { Inventory } from '../hoardings/inventory';

export class ConflictUnits {
    inventoryUnits: Inventory = new Inventory();
    inventoryGroups: Inventory[] = [];
}
